import React from 'react'
import Moment from 'moment'

export const GovMessageWhen = ({ dateTime }) => {
  const momentDateTime = Moment(dateTime)

  return (
    <time dateTime={dateTime} title={momentDateTime.fromNow()}>
      {momentDateTime.format('Do MMM YYYY')}
    </time>
  )
}



// WEBPACK FOOTER //
// ./src/ui/gov-messages/views/when.jsx